import React from "react";
import { CardTheme } from "../types";

interface ReverseSymbolProps {
  theme: CardTheme;
}

export const ReverseSymbol: React.FC<ReverseSymbolProps> = React.memo(({ theme }) => {
  const { width, height } = theme.card;
  const centerX = width / 2;
  const centerY = height / 2;
  const size = Math.min(width, height) * 0.3;
  const arrowSize = size * 0.3;
  const cornerFontSize = width * 0.12;

  // Draw two curved arrows pointing in opposite directions (reverse symbol)
  return (
    <g>
      {/* Top curved arrow (pointing left) */}
      <path
        d={`M ${centerX + size * 0.2} ${centerY - size * 0.2}
            A ${size * 0.3} ${size * 0.3} 0 0 0 ${centerX - size * 0.2} ${centerY - size * 0.2}
            L ${centerX - size * 0.2 + arrowSize * 0.3} ${centerY - size * 0.2 - arrowSize * 0.5}
            L ${centerX - size * 0.2 - arrowSize * 0.2} ${centerY - size * 0.2}
            L ${centerX - size * 0.2 + arrowSize * 0.3} ${centerY - size * 0.2 + arrowSize * 0.5}
            Z`}
        fill={theme.symbol.color}
      />
      {/* Bottom curved arrow (pointing right) */}
      <path
        d={`M ${centerX - size * 0.2} ${centerY + size * 0.2}
            A ${size * 0.3} ${size * 0.3} 0 0 0 ${centerX + size * 0.2} ${centerY + size * 0.2}
            L ${centerX + size * 0.2 - arrowSize * 0.3} ${centerY + size * 0.2 + arrowSize * 0.5}
            L ${centerX + size * 0.2 + arrowSize * 0.2} ${centerY + size * 0.2}
            L ${centerX + size * 0.2 - arrowSize * 0.3} ${centerY + size * 0.2 - arrowSize * 0.5}
            Z`}
        fill={theme.symbol.color}
      />
      
      {/* Top-left corner symbol */}
      <text
        x={width * 0.15}
        y={height * 0.2}
        fontSize={cornerFontSize}
        fontWeight="bold"
        fill={theme.symbol.color}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
      >
        🔄
      </text>

      {/* Bottom-right corner symbol (rotated) */}
      <text
        x={width * 0.85}
        y={height * 0.8}
        fontSize={cornerFontSize}
        fontWeight="bold"
        fill={theme.symbol.color}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
        transform={`rotate(180 ${width * 0.85} ${height * 0.8})`}
      >
        🔄
      </text>
    </g>
  );
});

ReverseSymbol.displayName = "ReverseSymbol";
